import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Loader from '../../utils/Loader';
import { startAttempt } from '../../redux/testPage/testPage.actions';
import MenuAnimation from '../utils/animations/menu';
const ScoreBar = ({
	score: { oLevel, rLevel, wLevel, lLevel, sLevel, showScore },
}) => {
	useEffect(() => {
		Loader.hide();
	}, []);

	return !!showScore ? (
		<MenuAnimation className="db-right dash-right-bar-width d-none d-sm-block">
			<span className="main-score-info">
				Based on your last test your score level is
			</span>
			<div className="dash-step-score main-score">
				<span className="dash-scored">{oLevel || '--'}</span>
				<span className="out-of">
					Out
					<br />
					of
				</span>
				<span className="dash-total">12</span>
			</div>
			<div className="dash-cat-score reading-score">
				<span>Reading</span>
				<span className="score-item">{rLevel || '--'}</span>
			</div>
			<div className="dash-cat-score writing-score">
				<span>Writing</span>
				<span className="score-item">{wLevel || '--'}</span>
			</div>
			<div className="dash-cat-score listening-score">
				<span>Listening</span>
				<span className="score-item">{lLevel || '--'}</span>
			</div>
			<div className="dash-cat-score speaking-score">
				<span>Speaking</span>
				<span className="score-item">{sLevel || '--'}</span>
			</div>
		</MenuAnimation>
	) : null;
};

const mapStateToProps = (state) => {
	return {
		score: state.rootReducer.myStepDetails.score,
		isRetail: state.rootReducer.loginDetails.isRetail,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(ScoreBar),
);
